module.exports = __webpack_public_path__ + "media/hero-video.e87092ec.mp4";